import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { LinkComponent } from '../../../LinkComponent';
import { REQUEST_RESULT } from '../SenseJS';
import { ButtonComponent } from '../../../ButtonComponent';
import './ErrorModal.scss';

interface Props {
	requestResult?: REQUEST_RESULT;
	// siteName: string;
	closeModal: () => void;
	openVerificationModal: () => void;
}

export const ErrorModal: FC<Props> = (props) => {
	const { closeModal, openVerificationModal, requestResult } = props;

	const getErrorText = (): string => {
		switch (requestResult) {
			case REQUEST_RESULT.SITE_NOT_FOUND: return 'Site not found';
			case REQUEST_RESULT.NOT_FOUND: return 'SenseJS not found';
			case REQUEST_RESULT.SITE_CAN_NOT_REACH: return 'Site can`t be reached';
			// case REQUEST_RESULT.TRACKING_CODE: return 'Tracking code not found';
		}
	};

	const handleClick = (): void => {
		closeModal();
		openVerificationModal();
	};

	return (
		<div>
			<div className="w-36px mx-auto my-10 d-flex align-items-center justify-content-center rounded-circle error-icon-container">
				<FontAwesomeIcon icon={faExclamation} width={22} className="text-danger"/>
			</div>
			<div className="text-center fw-bolder text-danger fs-6 mb-3">{getErrorText()}</div>
			<div className="text-center fs-8 mb-3">
				Please check you`ve correctly pasted the Flex tracking code into your sites body.
			</div>
			<div className="text-center fs-8">
				<LinkComponent
					link='mailto:support@flex-charge.com'
					isUnderLine
				>
					<div>
						<span>Need help with your tracking code?</span>
						<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-2 w-10px"/>
					</div>
				</LinkComponent>
			</div>

			<ButtonComponent
				buttonName="Try again"
				additionalClass="btn-sm d-block mx-auto mt-5"
				onButtonClick={handleClick}
			/>
		</div>
	);
};
